export default "__VITE_ASSET__uiOiqTGN__"